"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ratings = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _core = require("@material-ui/core");

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Star = _interopRequireDefault(require("@material-ui/icons/Star"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _moment = _interopRequireDefault(require("moment"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _FeedbackService = require("../../../KESI2/Services/FeedbackService");

var _useTimer = require("./useTimer");

var _LiveTickerMessage = _interopRequireDefault(require("./LiveTickerMessage.scss"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _strings = require("../Voting/strings");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _FeedbackProvider = require("./FeedbackProvider");

var _RatingFeedbackView = _interopRequireDefault(require("./RatingFeedbackView"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var ratings = [1, 2, 3, 4, 5];
exports.ratings = ratings;

var LiveTickerRating = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LiveTickerRating, _React$Component);

  var _super = _createSuper(LiveTickerRating);

  function LiveTickerRating(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LiveTickerRating);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectedAnswer", function (selectedAnswer) {
      _this.setState({
        selectedAnswer: selectedAnswer
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setHover", function (hover) {
      _this.setState({
        hover: hover
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendFeedback", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var selectedAnswer, result;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedAnswer = _this.state.selectedAnswer;
              _context.next = 3;
              return (0, _FeedbackService.pushFeedbackMessage)(_this.props.id, selectedAnswer.toString());

            case 3:
              result = _context.sent;

              _this.props.setTimer(0);

              _this.setState({
                votable: false
              });

              console.log(result);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = {
      quotedMessage: null,
      selectedAnswer: 0,
      hover: 0,
      votable: _this.props.active
    };
    return _this;
  }

  (0, _createClass2["default"])(LiveTickerRating, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.active !== this.props.active) {
        this.props.setTimer(0);
        this.setState({
          votable: this.props.active
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var message = _dompurify["default"].sanitize(this.props.message);

      var _this$state = this.state,
          selectedAnswer = _this$state.selectedAnswer,
          hover = _this$state.hover,
          votable = _this$state.votable;
      var _this$props = this.props,
          id = _this$props.id,
          completed = _this$props.completed;
      return /*#__PURE__*/_react["default"].createElement(_core.Card, {
        className: _LiveTickerMessage["default"].outer,
        key: "entry_".concat(message.id),
        id: message.id,
        style: this.props.isHidden ? {
          padding: 0,
          margin: 0,
          maxHeight: 0
        } : {
          padding: '7px',
          margin: '10px 0',
          maxHeight: '9999px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '20%',
          display: 'inline-block',
          verticalAlign: 'top',
          padding: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].author : _LiveTickerMessage["default"].authorMobile,
        color: "textSecondary",
        gutterBottom: true
      }, this.props.author), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].date : _LiveTickerMessage["default"].dateMobile,
        color: "textSecondary",
        gutterBottom: true
      }, (0, _moment["default"])(this.props.dateCreated).format('DD.MM.YYYY HH:mm'))), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '80%',
          display: 'inline-block',
          padding: 0,
          paddingLeft: 10,
          verticalAlign: 'top'
        }
      }, this.props.imageLink ? /*#__PURE__*/_react["default"].createElement("img", {
        style: {
          width: '100%',
          height: 'auto',
          display: 'block',
          position: 'relative',
          paddingBottom: '8px'
        },
        src: this.props.imageLink
      }) : null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].message : _LiveTickerMessage["default"].messageMobile,
        color: "textSecondary",
        gutterBottom: true,
        dangerouslySetInnerHTML: {
          __html: message
        }
      }), /*#__PURE__*/_react["default"].createElement("div", null, votable ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, ratings.map(function (rating) {
        return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          style: {
            padding: '8px'
          },
          key: rating,
          color: hover >= rating ? 'secondary' : selectedAnswer >= rating ? 'primary' : 'default',
          "aria-label": rating,
          onMouseEnter: function onMouseEnter() {
            return _this2.setHover(rating);
          },
          onMouseLeave: function onMouseLeave() {
            return _this2.setHover(0);
          },
          onClick: function onClick() {
            return _this2.setSelectedAnswer(rating);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Star["default"], null));
      })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.sendFeedback();
        },
        style: {
          marginTop: '8px'
        }
      }, (0, _strings.getString)('VOTE_NOW'))) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FeedbackProvider.FeedbackContext.Consumer, null, function (feedbacks) {
        return feedbacks && feedbacks[id] ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_RatingFeedbackView["default"], {
          feedback: feedbacks[id],
          ratings: ratings
        })) : /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          variant: "body1"
        }, "Keine Auswertung verf\xFCgbar");
      })))), completed !== 0 && /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '100%',
          padding: '8px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], {
        variant: "determinate",
        value: completed
      })));
    }
  }]);
  return LiveTickerRating;
}(_react["default"].Component);

LiveTickerRating.propTypes = {
  id: _propTypes["default"].string,
  userId: _propTypes["default"].string,
  key: _propTypes["default"].string,
  message: _propTypes["default"].string,
  dateCreated: _propTypes["default"].string,
  dateEdited: _propTypes["default"].string,
  isLatest: _propTypes["default"].bool,
  author: _propTypes["default"].string,
  imageLink: _propTypes["default"].string,
  isHidden: _propTypes["default"].bool,
  data: _propTypes["default"].object,
  duration: _propTypes["default"].string,
  setTimer: _propTypes["default"].func,
  completed: _propTypes["default"].number,
  active: _propTypes["default"].bool
};
LiveTickerRating.defaultProps = {
  isLatest: false,
  isExpert: false
};

var _default = (0, _useTimer.withTimer)(LiveTickerRating);

exports["default"] = _default;